export const LABELS = {
  TITLE: 'Get all your home services connected in minutes',
  SUBTITLE: (agencyCode?: string) =>
    `Let's make your house a home. ${
      agencyCode === 'NAX' || agencyCode === 'AU_SWIT' ? 'We partner with' : 'Sorted is'
    } Australia's first digital home services marketplace`,
  BUTTON: (agencyCode?: string) =>
    `Download ${agencyCode === 'NAX' || agencyCode === 'AU_SWIT' ? 'the app' : 'the app'}`,
};
